module.exports = __webpack_public_path__ + "static/media/configuracoes.1f98b2de.svg";